// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"ClipSpinner_spinnerContainer__A2pY4"};